import {
  Button,
  Input,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
} from '@chakra-ui/react';
import { useRef } from 'react';

export default function SaveModelDialog({
  isOpen,
  onClose,
  overwriteName,
  saveAsNewName,
  onSaveAsNewNameChange,
  onOverwrite,
  onSaveAsNew,
  isSaving,
}) {
  const cancelRef = useRef(null);

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      isCentered
      initialFocusRef={cancelRef}
    >
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Save model</ModalHeader>
        <ModalBody>
          {overwriteName ? (
            <>
              <Text mb={3}>Save your current inputs and results.</Text>
              <Button
                colorScheme="purple"
                onClick={onOverwrite}
                isLoading={isSaving}
                mb={4}
                width="full"
              >
                Overwrite &ldquo;{overwriteName}&rdquo;
              </Button>
              <Text fontSize="sm" color="gray.600" mb={2}>
                Or save as a new model:
              </Text>
            </>
          ) : (
            <Text mb={3}>Enter a name for this model.</Text>
          )}
          <Input
            value={saveAsNewName}
            onChange={(e) => onSaveAsNewNameChange(e.target.value)}
            placeholder="Model name"
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                onSaveAsNew();
              }
            }}
          />
        </ModalBody>
        <ModalFooter>
          <Button ref={cancelRef} onClick={onClose} isDisabled={isSaving}>
            Cancel
          </Button>
          <Button
            colorScheme="purple"
            onClick={onSaveAsNew}
            isLoading={isSaving}
            ml={3}
          >
            {overwriteName ? 'Save as new' : 'Save'}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
